import { RestService } from "./RestService";

export class TransactionService extends RestService {
  constructor() {
    super("/api/v1/transactions");
  }

  getChargedStatus(id) {
    return this.getImpl(`${id}/charged_status`).then(
      (response) => response.data
    );
  }

  reactiveEVouchers(id) {
    return this.postImpl(`${id}/reactive_evouchers`);
  }

  getInformation(id) {
    return this.getImpl(`${id}/information`).then((response) => response.data);
  }

  getPaymentPasses(id) {
    return this.getImpl(`${id}/payment_passes`).then(
      (response) => response.data
    );
  }

  getPaymentVouchers(id) {
    return this.getImpl(`${id}/payment_vouchers`).then(
      (response) => response.data
    );
  }

  getPaymentEVouchers(id) {
    return this.getImpl(`${id}/payment_evouchers`).then(
      (response) => response.data
    );
  }
}
